var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeUnderline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24959 3.52832H4.86584V10.7328C4.86584 13.1009 6.51959 14.8087 9.27246 14.8087C12.0253 14.8087 13.6791 13.1009 13.6791 10.7328V3.52832H12.2953V10.6417C12.2953 12.3179 11.1951 13.5329 9.27246 13.5329C7.34984 13.5329 6.24959 12.3179 6.24959 10.6417V3.52832ZM14.335 16.8753H4.20996V15.7503H14.335V16.8753Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeUnderline);
export default __webpack_public_path__ + "static/media/type-underline.993909bd74ba1ce9c4e6ff4ee353673a.svg";
export { ForwardRef as ReactComponent };